import { render, staticRenderFns } from "./b-checkbox.vue?vue&type=template&id=616834d6&scoped=true"
import script from "./b-checkbox.vue?vue&type=script&lang=js"
export * from "./b-checkbox.vue?vue&type=script&lang=js"
import style0 from "./b-checkbox.vue?vue&type=style&index=0&id=616834d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616834d6",
  null
  
)

export default component.exports